import { Grid } from '@mui/material'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'
import { Form, Formik } from 'formik'
import _ from 'lodash'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaTrash, FaTrashAlt } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { useGET_chapterByIdQuery } from 'redux/api/goalbankApi'
import { useGET_setupOptionsQuery } from 'redux/api/setupApi'
import { AppDispatch, RootState } from 'redux/store'
import { setCurriculumSelection } from 'redux/ui/goalbankUI'
import { GOALBANK_ITEM_TYPES, goalbankSelectionRemoveItem, toHtml } from 'utils/helpers'

interface IProps {
  hasSelection?: boolean
  visibleSections?: string[]
  disabledSections?: string[]
  setupPrefix?: string
  unitId: number
}


const Unit: FC<IProps> = ({ unitId, hasSelection=false, disabledSections=[], visibleSections=[], setupPrefix="" }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  
  const sections = GOALBANK_ITEM_TYPES
  const hiddenSections = ["units","section1","section2","section3","section4"]

  Object.keys(sections).forEach(k => {
    const [deleteFn] = sections[k].deleteHook ? sections[k].deleteHook() : [null]
    sections[k]["deleteFn"] = deleteFn

    const [addFn] = sections[k].addHook ? sections[k].addHook() : [null]
    sections[k]["addFn"] = addFn
  })

  const [selectedSection, setSelectedSection] = useState(null)
  const [showAddForm, setShowAddForm] = useState(false)
  const [seeAllSections, setSeeAllSections] = useState(false)

  const curriculumSelection = useSelector((state: RootState) => state['goalbank'].curriculumSelection)

  const toggleSection = (section, c) => {

    if(!hasSelection)return
    
    let selection = _.cloneDeep(curriculumSelection)
    if(!(unitId in selection))selection[unitId]={
      id: unitId,
      selection: {}
    }
    if(!(section in selection[unitId]["selection"]))selection[unitId]["selection"][section]=[]

    if(selection[unitId]["selection"][section].filter(s => s.id === c.id).length===0)
      selection[unitId]["selection"][section].push({
        ...c,
        unit_id: unitId,
      })
    else
      selection[unitId]["selection"][section]=selection[unitId]["selection"][section].filter(s => s.id !== c.id)

    dispatch(setCurriculumSelection(selection))
  }


  const curriculumSectionSelectedItems = (section) => {

    if(!(unitId in curriculumSelection)) return 0

    return section in curriculumSelection[unitId]["selection"] 
        ? curriculumSelection[unitId]["selection"][section].length : 0
  }

  const {data: chapterData} = useGET_chapterByIdQuery(unitId.toString(), {skip: !unitId})

  const { data: setupData } = useGET_setupOptionsQuery(null, {skip: setupPrefix === ""})



  const sidebarSections = chapterData && (setupData || setupPrefix === "") ? 
    Object.keys(sections).filter(s => 
      !hiddenSections.includes(s) &&
      (s in chapterData && chapterData[s].length > 0) &&
      (visibleSections.length == 0 || visibleSections.indexOf(s) > -1) &&
      (setupPrefix === "" || setupData.filter(sd => sd.slug == setupPrefix+"_"+s && sd.is_enabled).length == 1)
    ) : []

  return (
    chapterData && (setupData || setupPrefix === "") && <>
        <div style={{ fontSize: "18px", cursor: 'pointer' }} onClick={() => setSelectedSection(null)}><b>{t('goalbank.unit')} {chapterData.sort_order}:</b> {chapterData.title}</div>

        <Grid spacing={2} container mt={2}>
            <Grid item xs={12} lg={4}>
                <div style={{ height: '100%', borderRight: '1px solid gray' }}>
                    {sidebarSections.map((k, ki) => <div key={`section_menu_${k}`} style={{ display: ki<4 || seeAllSections ? 'block' : 'none'}}
                      className={`goalbank-section ${selectedSection==k ? 'selected' : ''}`}>
                        <div className={`goalbank-section-title`}
                            onClick={() => {
                                setShowAddForm(false)
                                setSelectedSection(k)
                            }}
                        >{sections[k].title} {curriculumSectionSelectedItems(k) > 0 
                            ? `(${curriculumSectionSelectedItems(k)})` : ''}</div>
                    </div>)}


                    {sidebarSections.length > 4 && !seeAllSections && 
                      <div className="goalbank-section">
                        <div className="goalbank-section-title" 
                          onClick={() => { setSeeAllSections(true) }} style={{ color: '#000' }}>
                            + {t('goalbank.all-other-characteristics')}
                        </div>
                      </div>
                    }
                </div>
            </Grid>
            <Grid item xs={12} lg={8}>
                <div style={{ paddingLeft: '20px' }}>

                  {!selectedSection && <div>
                      
                          {chapterData.description && <div dangerouslySetInnerHTML={toHtml(chapterData.description)} />}
                          {chapterData.duration && <div><b>{t('common.duration')}: {chapterData.duration}</b></div>}

                    </div>}
                  {
                    selectedSection && sections[selectedSection].type==='choices' && <>
                        <div style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '20px'}}>{sections[selectedSection].title}</div>
                        <div>
                            {(selectedSection in chapterData) && chapterData[selectedSection].map((c) => { 
                              
                              
                              const isSelected = (
                                (unitId in curriculumSelection) &&
                                (selectedSection in curriculumSelection[unitId]["selection"]) && 
                                curriculumSelection[unitId]["selection"][selectedSection].filter(sc => sc.id===c.id).length > 0
                              )

                              return <div key={`${selectedSection}_${c.id}`}>
                              
                                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                 <div>
                                  {hasSelection && !disabledSections.includes(selectedSection) ? <input type="checkbox" 
                                    onChange={(e) => {toggleSection(selectedSection, c)}} 
                                    checked={isSelected }/> 
                                    : <>&bull;</>} 
                                  </div>

                                  <div style={selectedSection == 'goalbank_lessons' 
                                      ? { border: '1px dashed #333', padding: '10px', flexGrow: 1 } 
                                      : {}
                                    }>
                                    <div>

                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {toggleSection(selectedSection, c)}} 
                                      >
                                        {selectedSection == "practices" && <b>{c.code} </b>}
                                        {selectedSection == "clusters" && <b>{t('goalbank.cluster')} {c.display_code}: </b>}
                                      </span>

                                      <div style={selectedSection == 'goalbank_lessons' 
                                      ? { fontWeight: 'bold' } 
                                      : {}
                                       }>
                                      
                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {toggleSection(selectedSection, c)}} 
                                      >
                                        {selectedSection == 'goalbank_lessons' && <span>{ c.sort_order }. </span>}{c.title} 
                                      </span>


                                      {c.can_delete && sections[selectedSection].deleteFn && <FaTrashAlt style={{
                                        marginLeft: '5px',
                                        position: 'relative',
                                        bottom: '-2px',
                                        cursor: 'pointer'
                                        }} 
                                        
                                        onClick={() => {
                                          sections[selectedSection].deleteFn(c.id)
                                          dispatch(setCurriculumSelection(goalbankSelectionRemoveItem(curriculumSelection,selectedSection,c.id)))
                                        }}
                                        />} 
                                        </div>
                                    </div>

                                    { sections[selectedSection].has_description && 
                                      <div style={{ marginTop: '5px', fontStyle: 'italic' }}
                                        dangerouslySetInnerHTML={toHtml(c.description)}
                                      /> }


                                      {selectedSection == "clusters"  && <div>

                                          {c.goals.map(cg => <div key={cg.id} style={{marginTop: '5px'}}>

                                              {hasSelection ? <input type="checkbox" 
                                                onChange={(e) => {toggleSection("goals", cg)}} 
                                                checked={
                                                    (
                                                      (unitId in curriculumSelection) &&
                                                      ("goals" in curriculumSelection[unitId]["selection"]) && 
                                                      curriculumSelection[unitId]["selection"]["goals"].filter(sg => sg.id===cg.id).length > 0
                                                    )
                                                    ? true : false }/> 
                                                : <></>}
                                            
                                              <span 
                                                style={{ cursor: 'pointer' }}  
                                                onClick={(e) => {toggleSection("goals", cg)}}>
                                                  <b>{cg.display_code}</b> {cg.title}
                                              </span>
                                            </div>)
                                          }
                                        </div>}


                                        {selectedSection == "goalbank_lessons" && c.goalbank_activities.length>0 && 
                                          <div style={{ marginTop: '20px' }}>
                                            <div><u>{t('goalbank.activities')}</u></div>

                                            {c.goalbank_activities.map(a => <div key={a.id}>
                                              {hasSelection ? <input type="checkbox" 
                                                onChange={(e) => {toggleSection("goalbank_activities", a)}} 
                                                checked={
                                                    (
                                                      (unitId in curriculumSelection) &&
                                                      ("goalbank_activities" in curriculumSelection[unitId]["selection"]) && 
                                                      curriculumSelection[unitId]["selection"]["goalbank_activities"].filter(sa => sa.id===a.id).length > 0
                                                    )
                                                    ? true : false }/> 
                                                : <>&bull;</>} 

                                                <span 
                                                  style={{ cursor: 'pointer' }}  
                                                  onClick={(e) => {toggleSection("goalbank_activities", a)}}>
                                                     {a.title}
                                                </span>
                                               

                                            </div>)}


                                        {selectedSection == "goalbank_lessons" && c.goalbank_exercises.length>0 && 
                                          <div style={{ marginTop: '20px' }}>
                                            <div><u>{t('goalbank.exercises')}</u></div>

                                            {c.goalbank_exercises.map(ex => <div key={ex.id}>
                                              {hasSelection ? <input type="checkbox" 
                                                onChange={(e) => {toggleSection("goalbank_exercises", ex)}} 
                                                checked={
                                                    (
                                                      (unitId in curriculumSelection) &&
                                                      ("goalbank_exercises" in curriculumSelection[unitId]["selection"]) && 
                                                      curriculumSelection[unitId]["selection"]["goalbank_exercises"].filter(se => se.id===ex.id).length > 0
                                                    )
                                                    ? true : false }/> 
                                                : <>&bull;</>} 

                                                <span
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={(e) => {toggleSection("goalbank_exercises", ex)}} 
                                                >
                                                  {ex.title} {ex.description && <span> - {ex.description}</span>}
                                                </span>
                                                

                                            </div>)}

                                          </div>}  
                                      </div>}

                                  </div>
                                </div>

                            </div>})
                            }

                              {/*
                              <div style={{ textAlign: 'right', marginTop: '10px' }}>
                               {!showAddForm && <SubmitButton
                                color={'success'}
                                text={`${t('common.add-new-item')}`}
                                sx={{ width: '10rem' }} 
                                isLoading={false} 
                                onClick={() => setShowAddForm(true)}                           
                                />
                               }

                                {showAddForm && sections[selectedSection].addFn &&
                                   <Formik
                                   enableReinitialize
                                   initialValues={{'title': ''}}
                                   onSubmit={(values: any) => {
                                    sections[selectedSection].addFn({
                                      ...values,
                                      unit_id: unitId
                                    })
                                    setShowAddForm(false);
                                   }}
                                 >
                                       <Form>
                                         <div style={{ display: 'flex', width: '100%', verticalAlign: 'center' }}>
                                            <div style={{ width: 'calc(100% - 120px)' }}>
                                                <InputField fieldProps={{ label: '', name: 'title' }}  />
                                            </div>
                                            <div style={{ paddingLeft: '5px' }}>
                                              <SubmitButton
                                                 color={'success'}
                                                 text={`Add`}
                                                 sx={{ width: '100px' }}
                                                 isLoading={false}
                                              />
                                             </div>
                                         </div>
                                       </Form>
                                 </Formik>
                                }
                              </div>*/}
                        </div>

                    </>
                  }  
                </div>            
            </Grid>
        </Grid>      
    </> 
  )
}

export default Unit
